import { Col, Container, Row } from "react-grid-system"
import H1 from "../../atoms/typography/H1"
import { HorizontalSpacer } from "../../atoms/spacers"
import ArticleCard from "../../molecules/news/ArticleCard"
import CardGrid from "../../atoms/layout/CardGrid"
import PaginationComponent from "../../molecules/PaginationComponent"
import { usePagination } from "../../../hooks/usePagination"
import { useNavigate } from "react-router-dom"
import LoadingSpinner from "../../atoms/LoadingSpinner"
import H3 from "../../atoms/typography/H3"
import { useArticleCollection } from "../../../hooks/news/useArticleCollection"
import SearchField from "../../atoms/inputs/SearchField"
import { useState } from "react"

const NewsPage: React.FunctionComponent = () => {
  const gotoPageIndex = (index: number) => navigate("/news?page=" + index)
  const navigate = useNavigate()
  const pageIndex = parseInt(new URL(window.location.href).searchParams.get("page") ?? "1")
  const { first, getPaginationProps, skip, onClickPage } = usePagination([5, 10, 15, 30], pageIndex, gotoPageIndex)
  const [searchTerm, setSearchTerm] = useState<string>("")
  const { data, loading, error } = useArticleCollection(skip, first, searchTerm)

  const header = (
    <>
      <HorizontalSpacer spacing={3} />
      <Row nogutter align="center" style={{ gap: "2rem 0rem" }}>
        <Col sm={8} xs={12}>
          <H1 bold>Resources</H1>
        </Col>
        <Col sm={4} xs={12} style={{ alignSelf: "flex-end" }}>
          <SearchField
            onChange={(e) => {
              onClickPage(1)
              return setSearchTerm(e)
            }}
          />
        </Col>
      </Row>
      <HorizontalSpacer spacing={3} />
    </>
  )

  if (!data || loading) {
    return (
      <Container>
        {header}
        <LoadingSpinner />
        <HorizontalSpacer spacing={16} />
      </Container>
    )
  }

  if (error) {
    return <H3>Error: {error.message}</H3>
  }

  const {
    articleCollection: { items },
  } = data

  return (
    <Container>
      {header}
      <CardGrid>
        {items.map((item) => (
          <ArticleCard key={item.sys.id} {...item} />
        ))}
      </CardGrid>
      <HorizontalSpacer spacing={4} />
      <Row justify="center">
        <PaginationComponent {...getPaginationProps(data.articleCollection.total)} />
      </Row>
      <HorizontalSpacer spacing={6} />
    </Container>
  )
}

export default NewsPage
